import { Row, Input, Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { TitleSummary } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const EmailsComponent = ({ field }) => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>{t('email')}</TitleSummary>

        {field?.value?.map((email, index) => (
          <Row key={index}>
            <Col md={24} key={field.idInput}>
              <Input value={email} />
            </Col>
          </Row>
        ))}
      </React.Fragment>
    </>
  );
};

EmailsComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
